/* eslint-disable */
import { useSelector } from 'react-redux';
import '../../styles/application_header.css';
import HomePageNav from './HomePageNav';

export default function ApplicationHeader(props) {
  const profileFormDetailsData = useSelector(
    (state) => state.profile.personalInfo
  );
  const session = sessionStorage.getItem("session") ? JSON.parse(sessionStorage.getItem("session")) : "";
  let sessionToken = session && session.jwtResponse.token;

  return (
    <div>
      {/* <nav className="navbar navbar-expand-xxl navbar-dark bg-color-first"></nav> */}
      <div className="header-container" style={{ position: 'relative' }}>
  <img src="/logos/bpsc-header.png" width="100%" />
  <a
    href="/"
    title="Home"
    className="home-link"
  ></a>
</div>

      {/* {sessionToken && <h1 className='profile_Name'> Welcome -   {profileFormDetailsData.genderLookupId == "328" ? "Mr." : (profileFormDetailsData.genderLookupId == "329" && profileFormDetailsData.maritalStatusLookupId == "365") ? "Mrs." : "Ms."}   {profileFormDetailsData?.englishFullName} </h1>} */}
      {sessionToken && <h1 className='profile_Name'> Welcome - {profileFormDetailsData?.englishFullName} </h1>}
      <HomePageNav {...props} />
    </div>
  )
};